import { FOLDER_TYPE } from "constants/documents";
import { LOCKED_FOLDER, PRIVATE_FOLDER } from "constants/fileTypes";

export const getFileType = (
  fileType: string,
  type: string,
  isLocked: boolean,
  isPrivate = false
): string => {
  if (isPrivate && type === FOLDER_TYPE) {
    return PRIVATE_FOLDER;
  }
  if (isLocked && type === FOLDER_TYPE) {
    return LOCKED_FOLDER;
  }
  return fileType;
};
